export const HEADER_HEIGHT = 50;
export const APP_INSTALLER_HEIGHT = 40;

export const BALANCE_BADGE_TOP_ID = "balance-badge-top";
export const ONBOARDING_DIALOG_CLASS_NAME = "onboarding-dialog";
